import { AttendanceLogs } from "./Attendance";
import { AttendanceDSMLogs } from "./AttendanceDSM";


export const AttendanceReport = {
  "sections": [
    AttendanceLogs,
    AttendanceDSMLogs
  ]
}